<div class="encabezado" [ngClass]="{'estatico' : estatico, 'abierto' : abierto && !estatico}">

     <div class="contenido">

        <div class="titulo">
            Evaluación 360
        </div>

        <div class="operacion left">
            <div class="openSidebar" (click)="CambiarEstaticoSideBar()">
                <div>
                    <span class="fa fa-bars"></span>
                </div>
            </div>
        </div>

        <div class="operacion right">

            <div class="opciones">
                <div>

                </div>

            </div>

        </div>

    </div>

</div>

<!-- Sidebar -->
<div class="sidebar" [ngClass]="{'abierto' : (estatico || abierto)}" > <!-- (mouseleave)="CambiarAbiertoSideBar(false)" (mouseenter)="CambiarAbiertoSideBar(true)" -->

     <div class="logoSistema">
        <!-- logo -->
        <div [hidden]="!sidebarCompleto" class="logoCompleto">
            <img [src]="logo" />
        </div>

        <!-- logo -->
        <div [hidden]="sidebarCompleto" class="logoSmall">
            <img [src]="logoSmall"/>
        </div>
    </div>


    <!-- Modulo -->
    <div class="panelMenu" [ngClass]="{'cerrado': !sidebarCompleto}">
        <ng-container *ngFor="let modulo of sistemaService.opcionesMenu let last = last">


            <ng-container *ngIf="last">
                <div class="divisor24 separadorFunciones"></div>
            </ng-container>

            <div class="pantallas" [ngClass]="{'cerrada': !sidebarCompleto, 'moduloCerrado' : !estatico}" (mouseenter)="CambiarAbiertoModulo(modulo, true)" (mouseleave)="CambiarAbiertoModulo(modulo, false)">
                 <div>

                    <!-- Opción principal -->
                    <div class="modulo" [ngClass]="{'last' : last, 'activo' : modulo.Activo, 'tituloOculto' : !sidebarCompleto}" (click)="OpcionSeleccionada(modulo, modulo)">

                         <!-- icono -->
                         <div class="icono" *ngIf="modulo.TipoIconoId == TipoIconoEnum.AweSomeFont">
                         <span class="fa {{modulo.Icono}}"></span>
                        </div>

                        <div class="icono" *ngIf="modulo.TipoIconoId == TipoIconoEnum.Svg" >
                             <svg-icon class="iconoSVG" src="data:image/svg+xml;base64,{{modulo.Icono}}"></svg-icon>
                        </div>

                        <div class="icono" *ngIf="modulo.TipoIconoId == TipoIconoEnum.SvgLocal" >
                             <svg-icon class="iconoSVG" src="{{modulo.Icono}}"></svg-icon>
                        </div>

                        <!-- título -->
                        <div class="titulo">
                            <span>
                                {{modulo.Titulo}}
                            </span>
                        </div>

                    </div>

                    <!-- Submodulo -->
                    <div class="submenu" [ngClass]="{'abierto':modulo.Abierto, 'esPantalla' : modulo.TipoModulo == TipoOpcionMenuEnum.Pantalla}"  [@expandCollapseDetails]="GetEstatusSubMenu(modulo.Abierto)" >


                         <ng-container *ngIf="!sidebarCompleto">
                            <div class="tituloSubmenu" (click)="IrPantalla(modulo)">
                                <div>{{modulo.Titulo}}</div>
                            </div>
                        </ng-container>

                        <ng-container *ngFor="let submodulo of modulo.SubMenu let last = last; let  first = first;">

                            <div class="opcionSubmenu" [ngClass]="{'activo' : submodulo.Activo}" (click)="OpcionSeleccionada(submodulo, modulo);">

                                 <!-- icono -->
                                 <div class="icono" *ngIf="submodulo.TipoIconoId == TipoIconoEnum.AweSomeFont">
                                 <span class="fa {{submodulo.Icono}}"></span>
                                </div>

                                <div class="icono" *ngIf="submodulo.TipoIconoId == TipoIconoEnum.Svg">
                                     <svg-icon class="iconoSVG" src="data:image/svg+xml;base64,{{submodulo.Icono}}"></svg-icon>
                                </div>

                                <div class="icono" *ngIf="submodulo.TipoIconoId == TipoIconoEnum.SvgLocal">
                                     <svg-icon class="iconoSVG" src="{{submodulo.Icono}}" ></svg-icon>
                                </div>

                                <!-- título -->
                                <div class="titulo">
                                    <span>
                                        {{submodulo.Titulo}}
                                    </span>
                                </div>

                                <ng-container *ngIf="submodulo.TipoModulo == TipoOpcionMenuEnum.SubModulo">

                                    <!-- icono -->
                                    <div class="icono abrir" [ngClass]="{'abierto' : submodulo.Abierto}">
                                     <span class="fa fa-chevron-down"></span>
                                    </div>

                                </ng-container>

                            </div>

                            <!-- Pantalla -->
                            <div class="submenu" [ngClass]="{'abierto':submodulo.Abierto}" [@expandCollapseDetails]="GetEstatusSubMenu(submodulo.Abierto)">

                                 <ng-container *ngFor="let pantalla of submodulo.SubMenu let last = last; let  first = first;">

                                    <div  class="opcionSubmenu ultimoNivel" [ngClass]="{'activo' : pantalla.Activo}" (click)="OpcionSeleccionada(pantalla, modulo)">

                                          <!-- icono -->
                                          <div class="icono" *ngIf="pantalla.TipoIconoId == TipoIconoEnum.AweSomeFont">
                                         <span class="fa {{pantalla.Icono}}"></span>
                                        </div>

                                        <div class="icono" *ngIf="pantalla.TipoIconoId == TipoIconoEnum.Svg">
                                             <svg-icon class="iconoSVG" src="data:image/svg+xml;base64,{{pantalla.Icono}}" ></svg-icon>
                                        </div>

                                        <div class="icono" *ngIf="pantalla.TipoIconoId == TipoIconoEnum.SvgLocal">
                                             <svg-icon class="iconoSVG" src="{{pantalla.Icono}}" ></svg-icon>
                                        </div>

                                        <!-- título -->
                                        <div class="titulo">
                                            <span>
                                                {{pantalla.Titulo}}
                                            </span>
                                        </div>

                                    </div>
                                </ng-container>

                            </div>

                        </ng-container>

                    </div>

                </div>
            </div>
        </ng-container>
    </div>

</div>
